import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from 'src/app/services';
import { TimeZoneService } from 'src/app/services/timeZone.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  public timeZone: string = "";
  public timeZoneOffset: string = "";
  timeZoneSub: Subscription;

  constructor(private authService: AuthService,
    private timeZoneService: TimeZoneService) { }

  ngOnDestroy(): void {
    if (this.timeZoneSub) {
      this.timeZoneSub.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.initialize();
    this.timeZoneSub = this.authService.refreshTimezone.subscribe(refresh => {
      if (refresh) {
        this.initialize();
      }
    });
  }

  initialize() {
    const currentUser = this.authService.getCurrentUser();
    this.timeZone = currentUser.userTimeZone;
    this.timeZoneOffset = this.timeZoneService.createTimeZoneLabel(this.timeZone);
  }

}
